import {Dispatch} from 'react'
import {COMPROBANTE_RETENCION_TYPES} from '../../constants/comprobanteRetencion.types'
import * as http from '../../api/http'
import {State} from '../../reducers'
import * as validators from '../../utils/validaciones'
import {generalOpenModalError, generalOpenToastInfo, generalOpenToastSuccess} from '../general.actions'
import {roundToTwo} from '../../utils/numbers.utils'
import { CRECalculoArrayProductos, ComprobanteRetencionAction, } from '../../interfaces/comprobante-retencion.interface'
import { DICCIONARIO } from '../../constants/Diccionario'
import { ENDPOINTS } from '../../api/config'
import { KEYS } from '../../constants/keysStorage'
import { getId, quitarAcentos, validarRegexLetras, validarRegexNumIdentificacion, validarRegexNumericoFloat2Decimales } from '../../utils/strings.utils'
import { REGEX_SERIE } from '../../constants/Regex'

// ******************************************************************************************
export const comprobanteRetencionOpenModalDocumentos = () => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALDOCUMENTO_SETOPEN, payload: true})

export const comprobanteRetencionCloseModalDocumentos = () => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALDOCUMENTO_SETOPEN, payload: false})

export const comprobanteRetencionHandleChangeInput = (data: any) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALDOCUMENTO_FORM_HANDLECHANGE, payload: data})

export const comprobanteRetencionAddErrors = (errors: any) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALDOCUMENTO_ADD_ERRORS, payload: errors})

export const comprobanteRetencionSetLoader = (flag: boolean) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALDOCUMENTO_SET_LOADER, payload: flag})

export const comprobanteRetencionModalSetDocumentos = (data: any) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALDOCUMENTO_SET_DOCUMENTOS, payload: data})

export const comprobanteRetencionModalSetUser = (data: any) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALDOCUMENTO_SET_USER, payload: data})

export const comprobanteRetencioAsociarDoc = (documento: any) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_DOCUMENTO_ASOCIAR, payload: documento})

export const comprobanteRetencionDesasociarDoc = (numeroControl: string) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_DOCUMENTO_DESASOCIAR, payload: numeroControl})

export const comprobanteRetencionModalsOpenQuitarTodo = () => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALELIMINAR_OPEN, payload: {activeQuitarTodo: true}, })

export const comprobanteRetencionDocumentosClearAll = () => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_ARRAYPRODUCTOS_CLEAR_ALL, payload: null, })

export const comprobanteRetencionArrayProductoDeleteOne = () => ({
  type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_ARRAYPRODUCTOS_DELETE_ONE,
  payload: null,
})

export const comprobanteRetencionArrayProductoSetCalculos = (calculos: CRECalculoArrayProductos) => ({
  type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_ARRAYPRODUCTOS_SET_CALCULOS,
  payload: calculos,
})

// documentos físicos
export const comprobanteRetencionFisicoHandleChange = (data: any) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FISICO_HANDLE_CHANGE, payload: data})
export const comprobanteRetencionFisicoAddErrors = (errors: any) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FISICO_ADD_ERRORS, payload: errors})
export const comprobanteRetencionFisicoOpenModal = (flag: boolean) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FISICO_MODAL_SETOPEN, payload: flag})
export const comprobanteRetencionFisicoSetEdit = (flag: boolean) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FISICO_SETEDIT, payload: flag})
export const comprobanteRetencionFisicoClear = () => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FISICO_CLEAR, payload: null})
export const comprobanteRetencionFisicoEditar = (doc: any) => ({ type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FISICO_EDITAR_DOC, payload: doc})



// ******************************************************************************************
// * ACCIONES DE MODALES
export const comprobanteRetencionModalsClose = () => ({
  type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_MODALELIMINAR_CLOSE,
  payload: null,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const comprobanteRetencionCalculoTotalArrayProducto = () => async (dispatch: Dispatch<ComprobanteRetencionAction>, getState: () => State) => {
    const documentosAsociados = getState().comprobanteRetencion.documentosAsociados
    let totalIvaRetenido : any = 0, totalMontoSujeto : any = 0

    if (documentosAsociados.length > 0) {
      documentosAsociados.forEach(documento => {
        totalMontoSujeto += Number(String(documento?.montoSujetoGrav))
        totalIvaRetenido += Number(String(documento?.ivaRetenido))
      });
    }
    dispatch(comprobanteRetencionArrayProductoSetCalculos({ totalIvaRetenido: roundToTwo(totalIvaRetenido), totalMontoSujeto: roundToTwo(totalMontoSujeto), }))
  }


// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const suscripcionVerificacionLimiteFacturas = () => async (dispatch: Dispatch<ComprobanteRetencionAction>, getState: () => State) => {
  if(getState().comprobanteRetencion.modalDocumentos.loader) return;
  dispatch(comprobanteRetencionSetLoader(true));
  const {form} = getState().comprobanteRetencion.modalDocumentos
  let message = 'No se lograron obtener Documentos Asociados'  
  const body = { nitEmision: form.numId, fechaDesde: `${form.inicio} 00:00:00`, fechaHasta: `${form.fin} 23:59:59`, tipoDte: form.tipo, nitVentaTercero: null, tokenGateway: localStorage.getItem(KEYS.TOKEN), }
  dispatch(comprobanteRetencionModalSetDocumentos([]));

  await http.post(ENDPOINTS.COMPROBANTE_RETENCION_BUSQUEDA_DTE, body, {}, KEYS.TOKEN)
  .then(async (res: any) => {
    if (res?.body?.status === "OK" && Array.isArray(res?.body?.body)) {
      let valores = res.body.body.filter((el:any) => el?.documento?.resumen?.ivaRete1);
      if(form.nombre) valores = valores.filter((el:any) => quitarAcentos(el?.documento?.receptor?.nombre).includes(quitarAcentos(form.nombre)));
      valores = valores.map((el:any) => {
        let monto = el?.documento?.identificacion?.tipoDte === "03" ? (el?.documento?.resumen?.totalGravada) : ((el?.documento?.resumen?.totalGravada - el?.documento?.resumen?.totalIva))
        return {
          TipoDte: el?.documento?.identificacion?.tipoDte, 
          tipoDoc: "1",
          numDocumento: el?.documento?.identificacion?.codigoGeneracion,
          fechaEmision: el?.documento?.identificacion?.fecEmi,
          montoSujetoGrav: roundToTwo(monto),
          codigoRetencionMH: "22",
          ivaRetenido:  String(el?.documento?.resumen?.ivaRete1),
          descripcion: "",
          fechaEmisionFormat: el?.documento?.identificacion?.fecEmi,
          numeroControl: el?.documento?.identificacion?.numeroControl,
          nombreReceptor: el?.documento?.receptor?.nombre,
        }
      })
      dispatch(comprobanteRetencionModalSetDocumentos(valores));
      if(valores.length === 0) dispatch(generalOpenToastInfo("No se obtuvieron resultados"))
      return
    }
    dispatch(generalOpenModalError(res?.message || message))
  })
  .catch((err: any) => {dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
  }).finally(() => dispatch(comprobanteRetencionSetLoader(false)))
}

export const creFormBusquedaValidacionesOnBlur = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => async (dispatch: Dispatch<ComprobanteRetencionAction>, getState: () => State) => {
  let {name, value} = e.target
  let message = validacionesOnBlurBusqueda(name, value, getState)
  dispatch(comprobanteRetencionAddErrors({[name]: message}))  
  const {inicio, fin} = getState().comprobanteRetencion.modalDocumentos.form
  if(inicio && fin && validarFecha(inicio, fin) ) dispatch(comprobanteRetencionAddErrors({inicio: "", fin: ""}))
}

export const creValidacionesOnSubmit = () => async (dispatch: Dispatch<ComprobanteRetencionAction>, getState: () => State) => {
  let {form: formUser, errorForm: formError} = getState().comprobanteRetencion.modalDocumentos
  let errors = {...formError}
  errors.inicio = validacionesOnBlurBusqueda('inicio', formUser.inicio, getState)
  errors.fin = validacionesOnBlurBusqueda('fin', formUser.fin, getState)
  errors.tipo = validacionesOnBlurBusqueda('tipo', formUser.tipo, getState)
  errors.numId = validacionesOnBlurBusqueda('numId', formUser.numId, getState)
  dispatch(comprobanteRetencionAddErrors(errors))  
  return Object.values(errors).some(error => error);
}

const validacionesOnBlurBusqueda = (name: string, value: string, getState: () => State) => {
  const {inicio, fin} = getState().comprobanteRetencion.modalDocumentos.form
  let message = ''
  switch (name) {
    case 'inicio':
      message = validators.validacionEsRequerido(value, message, "Fecha inicial", "requerida")
      if(!message && value && fin) message = validarFecha(value, fin) ? "" : "Fecha inicial no debe ser mayor a la final."      
      break
    case 'fin':
      message = validators.validacionEsRequerido(value, message, "Fecha final", "requerida")
      if(!message && value && inicio) message = validarFecha(inicio, value) ? "" : "Fecha final no debe ser menor a la inicial"   
      break
    case 'tipo':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.TIPO_DTE)
      break
    case 'numId':
      message = validators.validacionEsRequerido(value, message, getState().comprobanteRetencion.formCliente.nombreTipoDocumento)
      if (!message) message = validators.validacionMinLenght(value, message, 9)
      if (!message) message = validators.validarTipoDocumento(getState().comprobanteRetencion.formCliente.nombreTipoDocumento!, value, message)
      break
    default:
      break
  }
  return message
}

const validarFecha = (inicio: string, fin: string) => {
  const startDate = new Date(`${inicio}T00:00:00`);
  const endDate = new Date(`${fin}T00:00:00`);
  return startDate <= endDate 
};

export const creAsociarDocumentosNuevo = (documento: any) => async (dispatch: Dispatch<ComprobanteRetencionAction>, getState: () => State) => {
  const documentos = getState().comprobanteRetencion.documentosAsociados;
  if(documentos.length > 0) {
    let hasDifferentDocumentType = documentos.some(producto => (producto?.TipoDte !== documento.TipoDte));
    if (hasDifferentDocumentType) {
        dispatch(generalOpenToastInfo("No es permitido asociar diferentes tipos de documento."));
        return;
    }
    hasDifferentDocumentType = documentos.some(producto => (producto?.numDocumento === documento?.numDocumento));            
    if (hasDifferentDocumentType) {
        dispatch(generalOpenToastInfo(`El número de documento relacionado ${documento?.numDocumento}, ya se encuentra asociado.`));
        return;
    }
  }
  dispatch(comprobanteRetencioAsociarDoc(documento))
}

// DOCUMENTOS FÍSICO
export const creFormAgregarFisicoHandleChangeInput = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => (dispatch: Dispatch<ComprobanteRetencionAction>) => {
  let {name, value} = e.target
  if (value) {
    switch (name) {
      case 'numId':
        if (!validarRegexNumIdentificacion(value)) return
        value = value.toUpperCase();
        break
      case 'descripcion':
        if (!validarRegexLetras(value)) return
        break
      case 'monto':
        if (!validarRegexNumericoFloat2Decimales(value)) return
        break
      default:
        break
    }
  }
  calcularRetencion(dispatch, name, value)
  dispatch(comprobanteRetencionFisicoHandleChange({[name]: value}))
}

const calcularRetencion = (dispatch: Dispatch<ComprobanteRetencionAction>, name: string, value: string) => {
  if(name === "monto") {
    let monto = value ? Number(value) : 0;
    let retencion = monto * 0.01;
    dispatch(comprobanteRetencionFisicoHandleChange({retencion: roundToTwo(retencion)}))
  }
}

export const creAgregarFisicoOnBlur = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => async (dispatch: Dispatch<ComprobanteRetencionAction>) => {
  let {name, value} = e.target
  let message = validacionesOnBlurAgregar(name, value,)
  dispatch(comprobanteRetencionFisicoAddErrors({[name]: message})) 
}

export const creFisicoValidacionesOnSubmit = () => async (dispatch: Dispatch<ComprobanteRetencionAction>, getState: () => State) => {
  let {form: formUser, errorForm: formError} = getState().comprobanteRetencion.fisico
  let errors = {...formError}
  errors.tipo = validacionesOnBlurAgregar('tipo', formUser.tipo)
  errors.numId = validacionesOnBlurAgregar('numId', formUser.numId)
  errors.fecha = validacionesOnBlurAgregar('fecha', formUser.fecha)
  errors.descripcion = validacionesOnBlurAgregar('descripcion', formUser.descripcion)
  errors.monto = validacionesOnBlurAgregar('monto', formUser.monto)
  dispatch(comprobanteRetencionFisicoAddErrors(errors))
  return Object.values(errors).some(error => error);
}

const validacionesOnBlurAgregar = (name: string, value: string) => {
  let message = ''
  switch (name) {
    case 'tipo':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.TIPO_DTE)
      break
    case 'numId':
      message = validators.validacionEsRequerido(value, message, "Número de documento")
      if (!message) message = validators.validacionRegex(REGEX_SERIE, value, message, 'Número de documento')
      if (!message) message = validators.validacionMaxLenght(value, message, 36)
      break
    case 'fecha':
      message = validators.validacionEsRequerido(value, message, "Fecha de generación")
      break
    case 'descripcion':
      message = validators.validacionMaxLenght(value, message, 50)
      break
    case 'monto':
      message = validators.validacionEsRequerido(value, message, "Monto sujeto a retención")
      if (!message) message = validators.validacionNumMinimo(value, 0)
      if (!message) message = validators.validacionNumMaximo(value, 100000000000)
      break
    default:
      break
  }
  return message
}


export const creAgregarDocFisico = () => async (dispatch: Dispatch<ComprobanteRetencionAction>, getState: () => State) => {
  const documentos = getState().comprobanteRetencion.documentosAsociados;
  const fisico = getState().comprobanteRetencion.fisico.form
  const edit = getState().comprobanteRetencion.fisico.edit

  const documento = {
    id: fisico.id || getId(),
    TipoDte: fisico.tipo, 
    tipoDoc: "1",
    numDocumento: fisico.numId,
    fechaEmision: fisico.fecha,
    montoSujetoGrav: fisico.monto,
    codigoRetencionMH: "22",
    ivaRetenido:  fisico.retencion,
    fechaEmisionFormat: fisico.fecha,
    descripcion: fisico.descripcion,
    numeroControl: "--",
    nombreReceptor: "",
  }
  
  if (documentos.length > 0) {
    let hasDifferentDocumentType = documentos.some(producto => (producto?.TipoDte !== documento.TipoDte));
    if (hasDifferentDocumentType) {
        dispatch(generalOpenToastInfo("No es permitido asociar diferentes tipos de documento."));
        return;
    }
    hasDifferentDocumentType = documentos.some(producto => (producto?.numDocumento === documento?.numDocumento && producto?.id !== documento?.id));            
    if (hasDifferentDocumentType) {
        dispatch(generalOpenToastInfo(`El número de documento relacionado ${documento?.numDocumento}, ya se encuentra asociado.`));
        return;
    }
  }

  if(edit) {
    dispatch(comprobanteRetencionFisicoEditar(documento));
    dispatch(generalOpenToastSuccess("Documento actualizado exitosamente."))
    dispatch(comprobanteRetencionFisicoOpenModal(false))
  } else {    
    dispatch(comprobanteRetencioAsociarDoc(documento))
    dispatch(generalOpenToastSuccess("Documento agregado exitosamente."))
    dispatch(comprobanteRetencionFisicoClear())
  }
}

export const creEditarDatosDocumentoFisico = (documento: any) => async (dispatch: Dispatch<ComprobanteRetencionAction>, getState: () => State) => {
  const form: any = {
    id: documento.id,
    tipo: documento.TipoDte,
    numId: documento.numDocumento,
    fecha: documento.fechaEmision,
    descripcion: documento.descripcion,
    monto: documento.montoSujetoGrav,
    retencion: documento.ivaRetenido,
  }
  dispatch(comprobanteRetencionFisicoClear())
  dispatch(comprobanteRetencionFisicoHandleChange(form))
  dispatch(comprobanteRetencionFisicoOpenModal(true))
  dispatch(comprobanteRetencionFisicoSetEdit(true))
}